import React, { memo } from 'react';

const Status = ({ status }) => {
  // Determine classes based on status
  let statusClass = '';

  if (
    status === 'pending' ||
     status === 'Pending' ||
    status === 'running' ||
    status === 'inActive' ||
    status === 'blocked'  ||
     status === 'scheduled' ||
     status === 'pertially_paid' ||
     status === 'un-paid' ||
       status === 'Draft' ||
  status === 'draft'
  ) {
    statusClass = ' bg-[#FBF4E4] text-[#DBAA00]';
  } else if (
    status === 'completed' ||
    status === 'approved' ||
    status === 'claimed' ||
    status === 'active' ||
    status === 'accepted' ||
    status === 'success'  ||
     status === 'Active' ||
     status === 'Success' ||
     status === 'cleared' ||
     status === 'Cleared' ||
     status === 'paid' ||
     status === 'Paid' ||
     status=== "Transfer" ||
     status==='Transferred'||
     status==='Approved' ||
     	status==='Full Paid'

     

  ) {
    statusClass = 'bg-green-500 bg-opacity-30 text-green-800';
  } else if (
    status === 'declined' ||
    status === 'cancelled' ||
    status === 'refunded' ||
    status === 'rejected' ||
    status === 'expired' ||
        status === 'inactive' ||
                status === 'InActive' ||
                 status === 'Failed' ||
                   status === 'Unpaid'||
                   status === 'overdue'||
                   status === 'defaulted'||
                   status === 'bounced'||
                   status === 'Bounced'||

                    status === 'Not Assigned'||
                
   status === 'Deleted'||
    status === 'deleted'
  ) {
    statusClass = 'bg-red-500 bg-opacity-30 text-[#FF0000]';
  } else if (status === 'in progress' || status === 'In Progress' ) {
    statusClass = 'bg-blue-200 text-blue-800'; // light blue for in progress
  }else if (
  status === 'assigned' ||
  status === 'Assigned'  
) {
  statusClass = 'bg-blue-500 bg-opacity-30 text-blue-700';
}

  return (
    <div
      className={`${statusClass} text-sm px-2 rounded-md flex items-center gap-1 py-1 pb-1.5 font-medium w-fit capitalize`}
    >
      <span>{status==="bounced"?'Dishonored':status}</span>
    </div>
  );
};

export default memo(Status);
